<template>
  <div class="relative">
 
    <!-- Slide Panels -->
    <FrontendLayoutHeaderSlideAccount v-model="uiStore.accountSlide" />
    <FrontendLayoutHeaderSlideCart v-model="uiStore.cartSlide" />

    <!-- Main Header -->
    <div class="max-w-7xl mx-auto ">
      <div class="flex items-center justify-between py-6 px-8">
        <!-- Logo -->
        <NuxtLink
          href="/"
          class="shrink-0 transform hover:scale-105 transition-transform"
        >
          <img
            :src="logoSrc"
            class="w-[162px] h-auto"
            format="webp"
            width="102"
            height="45"
            alt="Logo"
          />
        </NuxtLink>

        <!-- Search -->
        <div class="flex-1 flex justify-center max-w-3xl px-16">
          <FrontendLayoutHeaderSearchInput class="w-full" />
        </div>

        <!-- Actions -->
        <div class="shrink-0">
          <div class="flex items-center gap-8">
            <button
              @click="toggleSlide('accountSlide')"
              class="flex flex-col items-center gap-1.5 group"
            >
              <div
                class="w-10 h-10 rounded-full bg-slate-50/80 flex items-center justify-center group-hover:bg-orange-50 transition-all"
              >
                <UIcon
                  name="i-heroicons-user-circle"
                  class="w-5 h-5 text-slate-700 group-hover:text-orange-500 transition-colors"
                />
              </div>
              <span
                class="text-[13px] font-medium text-slate-700 group-hover:text-orange-500 transition-colors"
                >Hesap</span
              >
            </button>

            <button
              @click="toggleSlide('cartSlide')"
              class="flex flex-col items-center gap-1.5 group relative"
            >
              <div
                class="w-10 h-10 rounded-full bg-slate-50/80 flex items-center justify-center group-hover:bg-orange-50 transition-all relative"
              >
                <UIcon
                  name="i-heroicons-shopping-bag"
                  class="w-5 h-5 text-slate-700 group-hover:text-orange-500 transition-colors"
                />
                <span
                  v-if="props.cart.totalItems > 0"
                  class="absolute -bottom-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-[11px] font-semibold text-white bg-orange-500 rounded-full shadow-sm"
                >
                  {{ cartBadgeLabel }}
                </span>
              </div>
              <span
                class="text-[13px] font-medium text-slate-700 group-hover:text-orange-500 transition-colors"
              >
                Sepet
              </span>
              <span
                v-if="props.cart.cartTotalAmount > 0"
                class="text-xs absolute -bottom-5 text-orange-500 bg-orange-50 px-2 py-0.5 rounded-md whitespace-nowrap shadow-sm"
                >{{ formatPrice(props.cart.cartTotalAmount) }}</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Categories -->
    <div class="bg-slate-100 border-t border-slate-200 ">
      <div class="max-w-7xl  mx-auto">
        <div class="px-8">
          <FrontendLayoutHeaderDesktopCategoryMenu
            :categories="props.categories"
            class="flex items-center text-[15px] font-medium  [&>*:first-child]:pl-0  [&>*]:text-slate-700 [&>*]:transition-colors [&>*:hover]:text-orange-500"
          />
        </div>
      </div>
    </div>
    <FrontendLayoutHeaderSlideNestedMenu
      v-model="uiStore.menuSlide"
      :menu="props.categories"
      :selected-category="selectedCategory"
    />
  </div>
</template>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

<script setup>
const props = defineProps({
  categories: {
    type: Array,
    default: () => []
  },
  cart: {
    type: Object,
    default: () => ({
      cartQyt: 0,
      cartTotalAmount: 0
    })
  }
})
const siteSettings = useSiteSettingsStore()
const logoSrc = computed(() => siteSettings.logoUrl)
const selectedCategory = ref(null)
const uiStore = useUiStore()
const cartBadgeLabel = computed(() => {
  const quantity = Number(props.cart?.totalItems ?? 0)
  if (quantity > 99) {
    return '99+'
  }
  if (quantity > 9) {
    return '9+'
  }
  return quantity
})

// Slide toggle işlevi
const toggleSlide = (slideKey) => {
  // Diğer tüm slide'ları kapat
  Object.keys(uiStore.$state).forEach((key) => {
    if (key !== slideKey && key.endsWith('Slide')) {
      uiStore[key] = false
    }
  })
  // İlgili slide'ı aç/kapat
  uiStore[slideKey] = !uiStore[slideKey]
}
</script>
